<template>
  <div class="container">
    <div class="info" v-if="info.id">
      <el-descriptions title="团队信息">
        <el-descriptions-item label="团队">{{
          info.team_name
        }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{
          info.team_type
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag type="info" size="small" v-if="info.status === 0"
            >待审核</el-tag
          >
          <el-tag type="success" size="small" v-if="info.status === 2"
            >通过</el-tag
          >
          <el-tag type="danger" size="small" v-if="info.status === 1"
            >审核拒绝</el-tag
          >
          <el-tag type="danger" size="small" v-if="info.status === 3"
            >冻结</el-tag
          >
        </el-descriptions-item>
        <el-descriptions-item label="擅长业务">{{
          info.specialty_categories || ""
        }}</el-descriptions-item>
        <el-descriptions-item label="资质">
          <div>
            <el-image
              v-for="(pic, index) in info.business_license_url.split(',')"
              style="width: 150px; height: 150px"
              :src="pic"
              fit="cover"
              :preview-src-list="info.business_license_url.split(',')"
              :key="index"
            ></el-image>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="团队介绍">
          <div v-if="info.desc_imgs">
            <el-image
              v-for="(pic, index) in info.desc_imgs.split(',')"
              style="width: 150px; height: 150px"
              :src="pic"
              fit="cover"
              :preview-src-list="info.desc_imgs.split(',')"
              :key="index"
            ></el-image>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="desc">
        {{ info.team_description || "暂无团队介绍" }}
      </div>
    </div>
    <div></div>

    <div v-if="audit.id">
      <el-descriptions title="团队修改信息">
        <template slot="extra">
          <el-button
            @click="updateStatus(2)"
            type="success"
            v-if="info.status === 0"
            >通过审核</el-button
          >
          <el-button
            @click="updateStatus(1)"
            type="danger"
            v-if="info.status === 0"
            >审核拒绝</el-button
          >
        </template>

        <el-descriptions-item label="团队">{{
          audit.team_name
        }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{
          audit.team_type
        }}</el-descriptions-item>
        <el-descriptions-item label="擅长业务">{{
          audit.specialty_categories || ""
        }}</el-descriptions-item>
        <el-descriptions-item label="资质">
          <div v-if="audit.business_license_url">
            <el-image
              v-for="(pic, index) in audit.business_license_url.split(',')"
              style="width: 150px; height: 150px"
              :src="pic"
              fit="cover"
              :preview-src-list="audit.business_license_url.split(',')"
              :key="index"
            ></el-image>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="团队介绍">
          <div v-if="audit.desc_imgs">
            <el-image
              v-for="(pic, index) in audit.desc_imgs.split(',')"
              style="width: 150px; height: 150px"
              :src="pic"
              fit="cover"
              :preview-src-list="audit.desc_imgs.split(',')"
              :key="index"
            ></el-image>
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="desc">
        {{ audit.team_description || "" }}
      </div>
    </div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="团队成员" name="member">
        <teamMember ref="member"></teamMember>
      </el-tab-pane>
      <el-tab-pane label="团队招生情况" name="stu">
        <teamInvite ref="stu"></teamInvite>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import teamInvite from '../components/teamInvite/teamInvite.vue';
import teamMember from "../components/teamMember/teamMember.vue";
export default {
  components: {
    teamInvite,
    teamMember,
  },
  data() {
    return {
      id: "",
      info: {},
      audit: {},
      activeName: "member",
      manager: JSON.parse(localStorage.getItem("managerInfo")),
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetails();
    this.$nextTick(() => {
      this.$refs.member.init();
    });
  },

  methods: {
    handleClick(tab) {
      this.$refs[tab.name].init();
    },
    updateStatus(status) {
      this.$post("/user/enrollTeamsAudit/update", {
        id: this.audit.id,
        status,
        review_id: this.manager.id,
        review_name: this.manager.name,
      }).then((res) => {
        this.$message("成功");
        this.info.status = status;
      });
    },
    getDetails() {
      this.$axios({
        url: "/user/enrollTeams/getById",
        params: {
          id: this.id,
        },
      }).then((res) => {
        let map = res.data.data;
        this.info = map.team;
        this.audit = map.audit || {};
      });
    },
  },
};
</script>

<style lang="less" scoped>
.info {
  margin-bottom: 30px;
}
.desc{
  white-space: pre-wrap;
}
</style>